import React from 'react'
import * as styles from '../SideBySideVideo.module.scss'

import { CampaignConfig } from '../config'
import { TrackFn } from '../SideBySideVideoPage'

type Props = {
  config: CampaignConfig
  onStart: () => void
  onEvent: TrackFn
}

const SplashStage = ({ config, onStart, onEvent }: Props) => {
  const { copy, branding } = config
  const mobileImg = branding.splashMobileImageSrc || branding.splashImageSrc

  const handleStart = () => {
    onEvent('step_interaction_sbsv_start')
    onStart()
  }

  return (
    <div className={styles.splash}>
      {/* Mobile hero image — hidden on desktop */}
      {mobileImg && (
        <div className={styles.splashMobileImage}>
          <img src={mobileImg} alt="" />
        </div>
      )}

      <div className={styles.splashCopy}>
        <h1>{copy.splashTitle}</h1>
        <p>{copy.splashSubtitle}</p>
        <button
          type="button"
          className={`${styles.btn} ${styles.btnWhitePill}`}
          onClick={handleStart}
          style={{ marginTop: 24 }}
        >
          {copy.splashCta}
        </button>
      </div>

      {/* Desktop side image — hidden on mobile */}
      {branding.splashImageSrc && (
        <div className={styles.splashImage}>
          <img src={branding.splashImageSrc} alt="" />
        </div>
      )}
    </div>
  )
}

export default SplashStage
